import { THROTTLE_SEC } from 'constants';
import { useEffect, useRef } from 'react';
import useCommonStore from './useCommonStore';

const useThrottle = (sec = THROTTLE_SEC) => {
  const { isLoading } = useCommonStore();

  const timeoutRef = useRef(null);
  const lockedRef = useRef(false);

  const resetThrottle = () => {
    clearTimeout(timeoutRef.current);
    lockedRef.current = false;
  };

  const throttle = (callback = () => {}) => {
    if (isLoading || lockedRef.current) return;

    lockedRef.current = true;

    try {
      callback?.();
    } finally {
      timeoutRef.current = setTimeout(() => {
        lockedRef.current = false;
      }, sec * 1000);
    }
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return { throttle, isThrottleLocked: lockedRef.current, resetThrottle };
};

export default useThrottle;
